/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOtherQaEquipmentDtoBrand1 } from './CreateOtherQaEquipmentDtoBrand1';
import {
    CreateOtherQaEquipmentDtoBrand1FromJSON,
    CreateOtherQaEquipmentDtoBrand1FromJSONTyped,
    CreateOtherQaEquipmentDtoBrand1ToJSON,
} from './CreateOtherQaEquipmentDtoBrand1';
import type { CreateOtherQaEquipmentDtoDeviceInterfaceType } from './CreateOtherQaEquipmentDtoDeviceInterfaceType';
import {
    CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSON,
    CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSONTyped,
    CreateOtherQaEquipmentDtoDeviceInterfaceTypeToJSON,
} from './CreateOtherQaEquipmentDtoDeviceInterfaceType';
import type { CreateOtherQaEquipmentDtoSingleDetectorConnectorType } from './CreateOtherQaEquipmentDtoSingleDetectorConnectorType';
import {
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON,
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSONTyped,
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON,
} from './CreateOtherQaEquipmentDtoSingleDetectorConnectorType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';

/**
 * 
 * @export
 * @interface CreateOtherQaEquipmentDto
 */
export interface CreateOtherQaEquipmentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOtherQaEquipmentDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherQaEquipmentDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof CreateOtherQaEquipmentDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateOtherQaEquipmentDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoBrand1}
     * @memberof CreateOtherQaEquipmentDto
     */
    brand1?: CreateOtherQaEquipmentDtoBrand1 | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoDeviceInterfaceType}
     * @memberof CreateOtherQaEquipmentDto
     */
    deviceInterfaceType?: CreateOtherQaEquipmentDtoDeviceInterfaceType | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoSingleDetectorConnectorType}
     * @memberof CreateOtherQaEquipmentDto
     */
    singleDetectorConnectorType?: CreateOtherQaEquipmentDtoSingleDetectorConnectorType | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherQaEquipmentDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    identification?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherQaEquipmentDto
     */
    $type?: CreateOtherQaEquipmentDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOtherQaEquipmentDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreateOtherQaEquipmentDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateOtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOtherQaEquipmentDtoTypeEnum = typeof CreateOtherQaEquipmentDtoTypeEnum[keyof typeof CreateOtherQaEquipmentDtoTypeEnum];


/**
 * Check if a given object implements the CreateOtherQaEquipmentDto interface.
 */
export function instanceOfCreateOtherQaEquipmentDto(value?: unknown): value is CreateOtherQaEquipmentDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOtherQaEquipmentDtoTypeEnum)[0];
}

export function CreateOtherQaEquipmentDtoFromJSON(json: any): CreateOtherQaEquipmentDto {
    return CreateOtherQaEquipmentDtoFromJSONTyped(json, false);
}

export function CreateOtherQaEquipmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherQaEquipmentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'brand1': !exists(json, 'brand1') ? undefined : CreateOtherQaEquipmentDtoBrand1FromJSON(json['brand1']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : CreateOtherQaEquipmentDtoDeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'defaultImageId': !exists(json, 'defaultImageId') ? undefined : json['defaultImageId'],
        'singleDetectorConnectorType': !exists(json, 'singleDetectorConnectorType') ? undefined : CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'isRegistrable': !exists(json, 'isRegistrable') ? undefined : json['isRegistrable'],
        'identification': !exists(json, 'identification') ? undefined : json['identification'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOtherQaEquipmentDtoToJSON(value?: CreateOtherQaEquipmentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value.isAvailable,
        'imageId': value.imageId,
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'typeNumber': value.typeNumber,
        'brand1': CreateOtherQaEquipmentDtoBrand1ToJSON(value.brand1),
        'deviceInterfaceType': CreateOtherQaEquipmentDtoDeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'defaultImageId': value.defaultImageId,
        'singleDetectorConnectorType': CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON(value.singleDetectorConnectorType),
        'isRegistrable': value.isRegistrable,
        'identification': value.identification,
        '$type': value.$type,
    });
}

